module.exports = __webpack_public_path__ + "static/media/火星人.2a652a89.png";